// extracted by mini-css-extract-plugin
export default {"dlRenderedDocument":"src-js-containers-document-components-RenderedDocument---dlRenderedDocument---8h1Ib"};